import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import React from "react";
import httpRequest from "../../services/httpRequest";
import snakecaseKeys from "snakecase-keys";

const _urlPrefix = "/schedule";

export const fetchAvailability = createAsyncThunk(
    "worker/fetchAvailability",
    async (params) => {
        const result = await httpRequest({
            url: `${_urlPrefix}/list`,
            params: snakecaseKeys(params),
            method: "GET"
        });
        if (!result) {
            return;
        }
        return result.data;
    }
);

const slice = createSlice({
    name: "schedule",
    initialState: {
        availability: {},
    },
    reducers: {

    },
    extraReducers: {
        [fetchAvailability.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.availability = payload;
            }
        }
    }
});

export const {  } = slice.actions;

export default slice.reducer;
